import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/my_fridge.png";
import logotext from "../assets/my_fridge_text.png";

const Footer = () => {
    return (
        <footer className="footer bg-light mt-5 py-3">
            <Container>
                <img src={logo} className="logo2 mb-4" alt="logo"/>
                <Row className="text-center">
                    <Col md={4} className="mb-3 mb-md-0">
                        <h5 className="text-success fw-bold">🍏 My Fridge</h5>
                        <p className="text-muted">Sleduj, co máš doma a nikdy nezapomeň dokoupit!</p>
                    </Col>
                    <Col md={4} className="mb-3 mb-md-0">
                        <h6 className="fw-bold">📌 Odkazy</h6>
                        <ul className="list-unstyled">
                            <li><a href="https://lexikonn.eu" className="text-decoration-none text-muted">🥦
                                Lexikonn.eu</a></li>
                        </ul>
                    </Col>
                    <Col md={4}>
                        <h6 className="fw-bold">📬 Kontakt</h6>
                        <p className="text-muted">
                            💌 <a href="mailto:thatsme@lexikonn.eu"
                                 className="text-decoration-none text-muted">thatsme@lexikonn.eu</a>
                        </p>
                    </Col>
                </Row>
                <Row className="text-center mt-3">
                    <Col>
                        <p className="text-muted small mb-0">
                            © {new Date().getFullYear()} My Fridge by Lexikonn. Všechna práva vyhrazena.
                        </p>
                    </Col>
                </Row>
                <img src={logotext} className="logotext2 mt-4" alt="logo"/>
            </Container>
        </footer>
    );
};

export default Footer;
